<header class="refund-receipt-dialog__header">
  <h2 mat-dialog-title>{{ 'customerInvoiceDetail.refundReceipt.title' | translate }}</h2>
  <button mat-icon-button type="button" [attr.aria-label]="'customerInvoiceDetail.refundReceipt.close' | translate" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</header>

<mat-dialog-content class="refund-receipt-dialog__body">
  <section>
    <h3>{{ 'customerInvoiceDetail.refundReceipt.customerData' | translate }}</h3>
    <p><strong>{{ 'customerInvoiceDetail.fields.client' | translate }}:</strong> {{ data?.invoice?.customer?.name_customer || '-' }} {{ data?.invoice?.customer?.lastName_customer || '' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.fields.code' | translate }}:</strong> {{ data?.invoice?.customer?.code_customer || '-' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.fields.contract' | translate }}:</strong> {{ data?.invoice?.customer_has_plan?.contractNumber_Plan || '-' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.fields.dni' | translate }}:</strong> {{ data?.invoice?.customer?.identifier_customer || '-' }}</p>
  </section>

  <section>
    <h3>{{ 'customerInvoiceDetail.refundReceipt.refundData' | translate }}</h3>
    <p class="refund-receipt-dialog__amount"><strong>{{ 'customerInvoiceDetail.refundReceipt.amount' | translate }}:</strong> {{ data?.currency || '' }} {{ getRefundAmount() ?? '-' }}</p>
    @if (getRefundTypeLabel(); as refundTypeLabel) {
      <p><strong>{{ 'customerInvoiceDetail.refunds.columns.type' | translate }}:</strong> {{ refundTypeLabel }}</p>
    }
    <p><strong>{{ 'customerInvoiceDetail.payments.columns.refundId' | translate }}:</strong> {{ getRefundId() ?? '-' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.refunds.columns.authorizationNumber' | translate }}:</strong> {{ getRefundAuthorizationNumber() }}</p>
    <p><strong>{{ 'customerInvoiceDetail.refundReceipt.date' | translate }}:</strong> {{ getRefundDate() ?? '-' }}</p>
    <p>
      <strong>{{ 'customerInvoiceDetail.payments.columns.status' | translate }}:</strong>
      {{ getRefundStatusLabel() ?? '-' }}
    </p>
  </section>

  <section>
    <h3>{{ 'customerInvoiceDetail.refundReceipt.originalPayment' | translate }}</h3>
    <p><strong>{{ 'customerInvoiceDetail.payments.columns.transactionId' | translate }}:</strong> {{ data?.payment?.transactionId || '-' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.payments.columns.description' | translate }}:</strong> {{ data?.payment?.description_payment || '-' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.refundReceipt.originalAmount' | translate }}:</strong> {{ data?.currency || '' }} {{ data?.payment?.amount_payment ?? '-' }}</p>
    <p><strong>{{ 'customerInvoiceDetail.payments.columns.transactionDate' | translate }}:</strong> {{ data?.payment?.transactionDate || '-' }}</p>
  </section>

  <p class="refund-receipt-dialog__verified">{{ 'customerInvoiceDetail.refundReceipt.verified' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions class="refund-receipt-dialog__actions" align="end">
  <button mat-raised-button type="button" color="primary" (click)="copyRefundReceipt()">{{ 'customerInvoiceDetail.refundReceipt.copy' | translate }}</button>
  <button mat-raised-button type="button" color="warn" (click)="downloadPdf()">{{ 'customerInvoiceDetail.refundReceipt.pdf' | translate }}</button>
  <button mat-button type="button" (click)="close()">{{ 'customerInvoiceDetail.refundReceipt.close' | translate }}</button>
</mat-dialog-actions>
